import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
// import './App.css';
import Header from './components/Header';
import Career from './components/career';
import JobDetails from './pages/JobDetails/JobDetails';
import Slideshow from './components/Slideshow';
import HousingServices from './components/HousingServices';
import ITServices from './components/ITServices';
import ServicesSection from './components/Services';
import JobListings from './pages/JobListings/JobListings';  
import DirectorDetails from './components/DirectorDetails';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ProtectedLayout from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import WelcomePage from './pages/WelcomePage';
import JobApplicationPage from './pages/JobApplication/index';
import UserListPage from './modules/user-management/UserListPage';
import MasterPage from './modules/application/MasterPage';
import JobOpeningsRoutes from './routes/JobOpeningsRoutes';
import CandidateList from './pages/CandidateList/CandidateList';

const HomePage = () => (
  <div className="App">
    <Header />
    <Slideshow />
    <HousingServices />
    <Career />
    <DirectorDetails />
    <Testimonials />
    <Contact />
    <Footer />
  </div>
);

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/job-application" element={<JobApplicationPage />} />
      <Route path="/career" element={<Career />} />   
<Route path="/job-Listings" element={<JobListings />} />  
      <Route path="/job-details" element={<JobDetails />} />  
      {/* Protected routes */}
      <Route element={<ProtectedLayout />}>
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/user-management/list" element={<UserListPage />} />
        <Route path="/job-openings/*" element={<JobOpeningsRoutes />} />
        <Route path="/application/master" element={<MasterPage />} />
        <Route path="/candidates" element={<CandidateList />} />
      </Route>
      
      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
